import { Outlet } from "react-router-dom";
import { useContext } from "react";

const AuthLayout = () => {
  return (
    <>
      <div className="auth-layout">
        <Outlet />
      </div>
    </>
  );
};

export default AuthLayout;